import React, { useEffect, useState } from "react";
import { handlingApi } from "units/handlingApi";

const UserFormData = () => {
  const [formData, setFormData] = useState([]);

  useEffect(() => {
    const fetchFormData = async () => {
      try {
        const url = `${process.env.REACT_APP_API_BASE_URL}admin/all-forms`;
        const res = await handlingApi({ url, method: "GET", data: {} });

        if (res.statusCode === 200) {
          setFormData(res.data);
        }
      } catch (error) {
        console.error("Error fetching form data:", error);
      }
    };

    fetchFormData();
  }, []);

  return (
    <div className="container">
      <h2 className="text-center my-4">User Form Submissions</h2>
      <table className="table table-bordered">
        <thead className="thead-dark">
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Email</th>
            <th>Message</th>
          </tr>
        </thead>
        <tbody>
          {formData.length > 0 ? (
            formData.map((form, index) => (
              <tr key={form._id}>
                <td>{index + 1}</td>
                <td>{form.name}</td>
                <td>{form.email}</td>
                <td>{form.message}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" className="text-center">
                No data found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default UserFormData;
